import { hexToRgba } from '@shared/utils'

import { GlobalToken } from 'antd'

import colors from './colors.json'

type ColorType = 'primary' | 'secondary'

export const getColor = (index: number, type: ColorType = 'primary'): string =>
  colors[type][index as unknown as keyof (typeof colors)[ColorType]]

export const getFunnelColor = (token: GlobalToken, index: number) => {
  return hexToRgba(token.colorPrimary, 0.4 + index * 0.15)
}
